import { cva } from "./index.ts";

export const collapsible = cva({
  base: "flex max-w-min whitespace-nowrap cursor-pointer items-center justify-between gap-2 rounded-sm border-0 bg-transparent text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 [&::-moz-focus-inner]:border-0",
  variants: {
    variant: {
      default: "py-2",
      compact: "py-1",
      spacious: "py-3",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const collapsibleArrow = cva({
  base: "shrink-0 transition-transform duration-200",
  variants: {
    open: {
      true: "rotate-90",
      false: "rotate-0",
    },
  },
  defaultVariants: {
    open: false,
  },
});
